import useScript from "@hooks/useScript";
import { cn } from "@util/helpers";

import { FLOURISH_REMOVE_CREDIT_TEXT_ID } from "./constants";

type FlourishEmbedProps = {
  /** The URL of the Flourish embed */
  url: string;
  /** Optional additional styling for the container */
  className?: string;
};

/**
 * FlourishEmbedCustom component that renders a Flourish embed.
 * It loads the Flourish embed script and displays the embed if the script is ready.
 */
const FlourishEmbedCustom = ({ url, className }: FlourishEmbedProps) => {
  const { isScriptReady } = useScript({
    id: "flourish-embed",
    src: "https://public.flourish.studio/resources/embed.js",
    type: "text/javascript",
  });

  if (typeof url === "undefined" && !isScriptReady) return <></>;

  return (
    <div
      className={cn("flourish-embed", className)}
      data-src={`${url}?${FLOURISH_REMOVE_CREDIT_TEXT_ID}`}
      data-testid="flourish-embed-custom-component"
    ></div>
  );
};

export default FlourishEmbedCustom;
